import classNames from 'classnames';
import React, { Component } from 'react';

import { TranslationsContext } from '@commons/translations-context';

import Longform from '@components/Longform';

import { testName } from '@utils/testUtils';

import NestedDropdown from './NestedDropdown';
import styles from './nestedDropdownWrapper.scss';

interface NestedDropdownWrapperProps {
  isMobile?: boolean;
  id: unknown;
  nddId?: string;
  validationEmpty?: string;
  validationFailed?: string;
  requiredField?: string;
  caption?: string;
  showFullNDD?: boolean;
  progressiveDisclosure?: boolean;
  filteredUnitList?: {
    closestUnits?: unknown[];
    name?: string;
  };
  dropdown?: unknown[];
  dropdowns?: unknown[];
}

export class NestedDropdownWrapper extends Component<NestedDropdownWrapperProps> {
  static contextType = TranslationsContext;

  static defaultProps = {
    isMobile: false,
    filteredUnitList: {},
    nddId: '',
    validationEmpty: '',
    validationFailed: '',
    requiredField: '',
    caption: '',
    showFullNDD: true,
    progressiveDisclosure: false,
    dropdown: [],
    dropdowns: []
  };

  constructor(props) {
    super(props);

    this.state = {
      showNestedDropdown: props.showFullNDD,
      hasBoxShadow: false
    };

    this.handleShowBoxShadow = this.handleShowBoxShadow.bind(this);
    this.handleHideBoxShadow = this.handleHideBoxShadow.bind(this);
    this.handleShowNddClickHandler = this.handleShowNddClickHandler.bind(this);
  }

  handleShowNddClickHandler() {
    this.setState({ showNestedDropdown: true });
  }

  handleShowBoxShadow() {
    if (this.state.hasBoxShadow) return;
    this.setState({ hasBoxShadow: true });
  }

  handleHideBoxShadow() {
    if (!this.state.hasBoxShadow) return;
    this.setState({ hasBoxShadow: false });
  }

  render() {
    const { id } = this.props;

    const findOtherLocationStyles = classNames(styles.findOtherLocation, {
      [styles.findOtherLocation_hasBoxShadow]: this.state.hasBoxShadow
    });

    return (
      <div>
        {this.state.showNestedDropdown ? (
          <NestedDropdown {...this.props} />
        ) : (
          <div {...testName('nearest-locations')}>
            <Longform id={id} key={id} />
            <div
              className={findOtherLocationStyles}
              onMouseOver={this.handleShowBoxShadow}
              onFocus={this.handleShowBoxShadow}
              onMouseOut={this.handleHideBoxShadow}
              onBlur={this.handleHideBoxShadow}
            >
              <a
                tabIndex="0"
                className={styles.findOtherLocationInner}
                onClick={this.handleShowNddClickHandler}
              >
                {this.context.translations.FIND_OTHER_LOCATIONS}
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default NestedDropdownWrapper;
// TODO: Consider tracking with RUM.
// export default withQuestionMeasurement(NestedDropdownWrapper, 'nestedDropdowns');
